var logos = [{
  id: 'c666b994-111c-492a-b7eb-a09e69aa9d77',
  image: {
    alt: 'walt disney',
    src: '//images.ctfassets.net/w6r2i5d8q73s/3QprsUQUW3jUrdMAwddn2H/d8b341c01c25147c0a56b0f52b6b1443/walt_disney.svg',
    width: 128,
    height: 48
  }
}, {
  id: '56efbff8-8fd9-4531-a911-4aef754ec735',
  image: {
    alt: 'asos',
    src: '//images.ctfassets.net/w6r2i5d8q73s/8y8TUx9LpVRKbqukOcZC2/9a5321a69701fde64514dd201e3bc992/asos.svg',
    width: 128,
    height: 48
  }
}, {
  id: '6a9d4b90-9837-486b-8054-f23b2e36dd21',
  image: {
    alt: 'contentful',
    src: '//images.ctfassets.net/w6r2i5d8q73s/19qFNu9U2mSevNXUtiPBfN/1ac215d9995bfcba45f7cf461302820a/contentful.svg',
    width: 128,
    height: 48
  }
}, {
  id: '0ebe63a1-302a-443f-bd71-a703cfcd3efc',
  image: {
    alt: 'ubisoft',
    src: '//images.ctfassets.net/w6r2i5d8q73s/3YZJ2vkIzuHgZJO2Dcxh5e/5666399b331fd03327d027121ae5d85a/ubisoft.svg',
    width: 128,
    height: 48
  }
}, {
  id: 'c662e629-4617-4a3d-83fc-a2b8a43b3c92',
  image: {
    alt: 'pepsico',
    src: '//images.ctfassets.net/w6r2i5d8q73s/6EFWQKfOYbpTv43Hm84p0t/600efe08eea24d50568e0ec41ce19c07/pepsico.svg',
    width: 128,
    height: 48
  }
}, {
  id: 'e1f29759-dc31-4643-a260-897dcec40329',
  image: {
    alt: 'macys',
    src: '//images.ctfassets.net/w6r2i5d8q73s/7r3aM4IuiXRmsiIc77h2qK/dd1f9862bcbe74d39635b9465be9945e/macys.svg',
    width: 128,
    height: 48
  }
}, {
  id: '4978c8fe-d3f9-4682-a1a4-902635456489',
  image: {
    alt: 'whirlpool',
    src: '//images.ctfassets.net/w6r2i5d8q73s/pJfdnxHOM7YsJlmNyhuBv/ec04483e170ae6df33fd4d314a5dbb60/whirlpool.svg',
    width: 128,
    height: 48
  }
}, {
  id: '33d23b4d-12da-4b27-9a56-c137b3067a12',
  image: {
    alt: 'hanes',
    src: '//images.ctfassets.net/w6r2i5d8q73s/gBX7PH3LqE6V8twqr2OOw/4fa7020f3152a0695c3a53dc050f31cd/hanes.svg',
    width: 128,
    height: 48
  }
}, {
  id: '7cea1596-56d8-4917-993c-b044d6d95658',
  image: {
    alt: 'yamaha',
    src: '//images.ctfassets.net/w6r2i5d8q73s/BtJIlcUVfpe9jzMmMKYqm/45e20b86be185bc049ad0e5138a51f55/yamaha.svg',
    width: 128,
    height: 48
  }
}, {
  id: 'd6f51786-80cb-41f8-bc52-c42c984fbd32',
  image: {
    alt: 'docusign',
    src: '//images.ctfassets.net/w6r2i5d8q73s/6lBp4DlhJZaNlGqoNdEXsp/4f8e2437c0c54ede8f38e6550382f310/docusign.svg',
    width: 128,
    height: 48
  }
}, {
  id: 'c1f37676-3959-45eb-97c0-63fa69e69090',
  image: {
    alt: 'liberty mutual',
    src: '//images.ctfassets.net/w6r2i5d8q73s/1QagzRLW8o5mSryN9qN4KX/9c62612ee95f570382bfe4248924468f/liberty_mutual.svg',
    width: 128,
    height: 48
  }
}, {
  id: 'ee173904-78ab-4e50-bd8e-76f5ab9b7d7e',
  image: {
    alt: 'wp engine',
    src: '//images.ctfassets.net/w6r2i5d8q73s/4fxqUuWzZ1g7YMh8EFyf64/5054f2a6c219e0c3f6dca9bb5f4ed91b/wp_engine.svg',
    width: 128,
    height: 48
  }
}, {
  id: 'c353fb2d-aff5-468e-ad55-7d235d5863f8',
  image: {
    alt: 'accenture',
    src: '//images.ctfassets.net/w6r2i5d8q73s/7qqYuOhg1XTnQgadkFNiAI/4ccc945909c01ae4f801ecad10f0bf61/accenture.svg',
    width: 128,
    height: 48
  }
}, {
  id: '15f798a1-4bd0-4aa1-83cb-117daefc9382',
  image: {
    alt: 'bumble',
    src: '//images.ctfassets.net/w6r2i5d8q73s/BhL17cEmDGUPTio403hVd/f5b4b37f3d18d356bdfcf0e441322e34/bumble.svg',
    width: 128,
    height: 48
  }
}, {
  id: '86d2af10-60e2-4ff9-a610-53a655dcf150',
  image: {
    alt: 'delloite',
    src: '//images.ctfassets.net/w6r2i5d8q73s/438pyocvf5kV5oXCP6magW/6d8b17095a730118af06c6056ae53d7e/delloite.svg',
    width: 128,
    height: 48
  }
}, {
  id: '74694510-c2e9-4504-8ce3-898eaabd4867',
  image: {
    alt: 'hewlett packard',
    src: '//images.ctfassets.net/w6r2i5d8q73s/5sxr5YBvnv2JVPyQhzGUEr/f75d9d3bf08c75ba52070cd085f96d14/hewlett_packard.svg',
    width: 128,
    height: 48
  }
}, {
  id: '31dde465-45d5-4d5d-a414-209bacc8a991',
  image: {
    alt: 'total',
    src: '//images.ctfassets.net/w6r2i5d8q73s/1nlToYxzQ6hq8RtTZB0e7n/75c6243dcfcbf465bdeee5b13d6a6a92/total.svg',
    width: 128,
    height: 48
  }
}, {
  id: 'f3ed8eee-000c-46a1-a07b-54d3466329ee',
  image: {
    alt: 'dropbox',
    src: '//images.ctfassets.net/w6r2i5d8q73s/3wvKK3Upra0CHNnMkDqNhd/737d1b75c2b2e6cc481c179f78b50687/dropbox.svg',
    width: 128,
    height: 48
  }
}];
export { logos };